export default "__VITE_ASSET__BQib2vuw__"